var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"fill":"currentColor","d":"M12 15l-6-6h12z","fill-rule":"evenodd"}})])}
var staticRenderFns = []

export { render, staticRenderFns }